import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import { IMG_ABOUT_MAIN, IMG_UREA_HAND } from "./assets";

const tags = [
  { icon: "fa-qrcode", label: "GS1 QR" },
  { icon: "fa-map-location-dot", label: "300+ Districts" },
  { icon: "fa-user-check", label: "Farmer Verified" },
  { icon: "fa-robot", label: "AI Fraud Detection" },
];

export default function About() {
  return (
    <section className="section" id="about" data-testid="about-section">
      <div className="section-inner about-grid">
        <Reveal className="about-images">
          <div className="about-img-main">
            <img src={IMG_ABOUT_MAIN} alt="Farmer scattering fertilizer in paddy field" />
          </div>
          <div className="about-img-sub">
            <img src={IMG_UREA_HAND} alt="Fertilizer granules in hand" />
          </div>
          <div className="about-badge">
            <div className="num">15+</div>
            <div className="label">States Live</div>
          </div>
        </Reveal>

        <Reveal>
          <span className="section-eyebrow">About Fertilizer Tracking</span>
          <h2 className="section-heading">
            Bringing <em>transparency</em> to every bag of Fertilizer, from Manufacturing Plant to plough.
          </h2>
          <p className="section-desc">
            Fertilizer Tracking is a nationwide QR traceability platform for subsidised
            fertiliser. Companies print GS1-compliant QR codes on every bag. Each scan
            along the supply chain — factory, warehouse, dealer, farmer — updates a live
            dashboard, triggers fraud checks and confirms genuine delivery.
          </p>

          <div className="about-tags">
            {tags.map((t) => (
              <span key={t.label} className="tag">
                <i className={`fa-solid ${t.icon}`}></i>
                {t.label}
              </span>
            ))}
          </div>

          <Link to="/login" className="btn-dark" data-testid="about-cta">
            Explore Dashboard <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
